import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {AgGridEvent, ColumnPinnedEvent, ColumnState} from '@ag-grid-community/core';
import {AdRequestOptions} from '../../interfaces/ad-reports';
import {Observable} from 'rxjs';
import {ReportsTableService} from '../../services/reports-table.service';
import {AgGridComponent} from '../ag-grid/ag-grid.component';
import {ReportStore} from "../../store/report/report.store";
import {Column, ColumnResizedEvent} from '@ag-grid-enterprise/all-modules';
import {ReportTableStore} from '../../store/report/report-table.store';
import {ReportParamsStore} from '../../store/report/report-params.store';

@Component({
  selector: 'app-ad-reports-table',
  templateUrl: './ad-reports-table.component.html',
  styleUrls: ['./ad-reports-table.component.scss']
})
export class AdReportsTableComponent implements OnInit, OnDestroy {
  @ViewChild(AgGridComponent) public readonly agGridC: AgGridComponent;

  @Input() public suppressTotals: boolean = false;
  @Input() public suppressPageTotals: boolean = false;
  @Input() public suppressSizeColumnToFit: boolean =  true;
  @Input() public readonly: boolean = false;

  @Input() public options: Partial<AdRequestOptions> | null;

  @Output() public onReady: EventEmitter<AgGridEvent> = new EventEmitter<AgGridEvent>();
  @Output() public onDragStop: EventEmitter<{ dimensions: Array<string>, metrics: Array<string> }> = new EventEmitter<{ dimensions: Array<string>, metrics: Array<string> }>();
  @Output() public onTableChanges: EventEmitter<AgGridEvent> = this._reportTableStore.onChanges$;

  public readonly defaultColDef:  any = {
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset', 'apply']
    }
  };

  public readonly gridOptions: any = {
    suppressDragLeaveHidesColumns: true,
    groupHeaderHeight: 35,
    headerHeight: 35,
    rowHeight: 46
  };

  private _agGrid: AgGridEvent;

  public readonly rowCount$: Observable<number> = this._reportTableStore.rowCount$;
  public readonly pageSize$: Observable<number> = this._reportTableStore.pageSize$;

  constructor(
    private readonly _adReportsTableS: ReportsTableService,
    private readonly _reportStore: ReportStore,
    private readonly _reportTableStore: ReportTableStore,
    private readonly _reportParamsStore: ReportParamsStore
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  public gridReady(params: AgGridEvent): void {
    this._agGrid = params;
    this._reportTableStore.init(params, this.suppressTotals, this.suppressPageTotals);
    this.onReady.emit(params);
  }

  public onDragStopped(params: AgGridEvent): void {
    const columns: Array<Column> = params.columnApi.getAllColumns();
    const columnsState: Array<ColumnState> = params.columnApi.getColumnState();
    const dimensions: Array<string> = [];
    const metrics: Array<string> = [];

    for (const columnState of columnsState) {
      const column: Column = columns.find((c: Column): boolean => c.getColId() === columnState.colId);

      if ('dimension' in (column.getColDef() as any).params) {
        dimensions.push(columnState.colId);
      } else {
        metrics.push(columnState.colId);
      }
    }

    // to do update
    this._reportTableStore.updateColumnsOrder(dimensions, metrics);

    this.onDragStop.emit({
      dimensions,
      metrics
    });
  }

  public getContextMenuItems(params: any) {
    return [
      'copy',
      'copyWithHeaders'
    ];
  }

  public processCellForClipboard(params: any): any {
    return params.value[params.column.colDef.params.formatted] || params.value[params.column.colDef.params.value] || '-';
  }

  public onPaginationPageSizeChanged(limit: number): void {
    this._reportTableStore.changePaginationPageSize(limit);
    this.onTableChanges.emit(this._agGrid);
  }

  public saveTable(params: ColumnPinnedEvent | ColumnResizedEvent): void {
    if (['uiColumnDragged', 'api'].includes(params.source)) {
      this._reportStore.updateRequestParamsSubmitted({ column_state: params.columnApi.getColumnState() });
      this.onTableChanges.emit(this._agGrid);
    }
  }

  public onColumnMoves(): void {
    this.onTableChanges.emit(this._agGrid);
  }

  public onSortChanged(params: AgGridEvent): void {
    const orders = this._adReportsTableS.getTableOrders(params);

    this._reportStore.updateRequestParamsSubmitted({
      dimension_orders:  orders.dimension_orders,
      metric_orders: orders.metric_orders
    });
  }

  public onFilterChanged(params: AgGridEvent): void {
    const filters = this._adReportsTableS.getTableFilters(params);

    this._reportStore.updateRequestParamsSubmitted({
      dimension_filters: filters.dimension_filters,
      metric_filters: filters.metric_filters
    });
  }

}
